// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/images/black-friday/bf22_bg.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.appbar-black-finde > .app-bar-generic {
  height: 6vh;
  padding-top: 0;
}

.appbar-black-finde > .app-bar-generic > .parrafo-new-appbar {
  margin-top: 0;
}

.appbar-black-finde
  > .app-bar-generic
  > .parrafo-new-appbar
  > .icono-color-new-appbar {
  color: #fff;
}

.bf-header-logo {
  padding-top: 7vh;
  padding-bottom: 4vh;
  position: fixed;
  width: 100vw;
}

.bf-logo {
  margin: 0 auto;
  margin-top: 2rem;
  width: 90vw;
}

.bf-content {
  font-family: "RedHatDisplay-Regular", sans-serif !important;
  overflow-y: scroll;
  position: relative;
  top: 2vh;
  width: 100vw;
}

.bf-background {
  background: #e3e3e3 url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
  background-size: contain;
  height: 100vh;
  overflow: scroll;
  position: fixed;
  z-index: -1;
}

.bf-counter-text {
  font-weight: 900;
  font-size: 1.2rem;
  color: #fff;
  line-height: 1.2rem;
  text-align: left;
  margin: 1rem 1.2rem;
}

.bf-counter {
  margin: 0 auto;
  width: 90vw;
}

.bf-clock-item {
  background-color: #ffffff15;
  border-radius: 10px;
  color: #fff;
  width: 17.5vw;
  height: 17vw;
  display: inline-block;
  padding: 2vw 3vw;
  margin: 1vw;
  text-align: left;
}

.bf-clock-number {
  font-size: 7.2vh;
  font-weight: 800;
  line-height: 6vh;
  font-family: "RedHatDisplay-Bold" !important;
}

.bf-clock-text {
  font-size: 1.7vh;
}

.bf-discount-prox,
.bf-dates-info,
.bf-promo-info {
  border-radius: 4px;
  margin: 0 auto;
  margin-top: 2vh;
  padding-top: 2vh;
  padding-bottom: 2vh;
  width: 90vw;
}

.bf-discount-prox {
  background-color: #3a3a3a;
}

.bf-discount-img img {
  max-width: 70vw;
}

.bf-dates-info,
.bf-promo-info {
  background-color: #fff;
}

.bf-promo-info {
  height: auto;
  margin-bottom: 2vh;
  padding-bottom: 3vh;
  padding-right: 2vw;
  width: 88vw;
}

span.bf-icon {
  float: left;
  margin: 0 3.5vw 0 5vw;
}

span.bf-dialog-icon {
  width: 16vw;
  height: 16vw;
  border-radius: 16px;
  background-color: #000;
  text-align: center;
  position: relative;
  display: block;
  margin: 0 auto;
}

span.bf-dialog-icon img {
  position: absolute;
  display: inline-block;
  max-height: 100%;
  max-width: 100%;
  width: auto;
  height: auto;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}

.bf-strong {
  font-weight: 900 !important;
  font-family: "RedHatDisplay-Black" !important;
}

.bf-prox-text,
.bf-discount-info-text,
.bf-info-text,
.bf-info-header,
.bf-info-steps,
.bf-step {
  display: block;
  text-align: left;
  font-size: 3.4vw;
  font-weight: 900;
  line-height: 5vw;
}

.bf-prox-text {
  color: #fff;
}

.bf-info-text {
  color: #2b363b;
  font-weight: normal;
  display: block;
}

.bf-discount-info-text {
  color: #2b363b;
  font-size: 3.4vw;
}

.bf-red {
  color: #db0b27;
  font-size: 3.4vw;
}

.bf-discount-info > .bf-red {
  font-weight: normal;
}

.bf-discount {
  background-color: #fff;
  border-radius: 4px;
  margin: 0 auto;
  padding-top: 1.9vh;
  padding-bottom: 1.9vh;
  width: 90vw;
}

.bf-discount-info,
.bf-discount-price,
.bf-price-legend,
.bf-price-cents {
  display: block;
}

.bf-discount-price {
  margin-top: 2vh;
  font-weight: 900;
}

.bf-price-legend,
.bf-price-cents {
  color: #6ca452;
}

.bf-price-legend {
  font-size: 3.4vw;
  letter-spacing: 0.1em;
}

.bf-price-cents {
  font-size: 2.5em;
  margin-top: 1vh;
}

.bf-price-small {
  color: #2b363b;
  font-size: 0.4em;
}

.bf-step-number {
  background-color: #db0b27;
  color: #fff;
  border-radius: 50%;
  font-size: 0.8em;
  padding: 0.2em 0.8em;
  float: left;
  margin: 3vh 5vw 0 5vw;
  line-height: 1.8em;
}

.bf-step {
  font-weight: 400;
  margin-top: 3vh;
  display: inline-block;
  width: 78%;
}

.bf-link {
  color: #db0b27;
  font-weight: 800;
}

.mymodalblackfinde {
  font-family: "RedHatDisplay-Regular", sans-serif !important;
  z-index: 4;
  left: 10vw;
  width: 80vw;
  background-color: #fff;
  overflow: auto;
  border-radius: 30px;
  margin: 30% auto;
}

.mymodalblackfinde:focus-visible,
.mymodalblackfinde:focus {
  outline-width: 0;
  outline: none;
}

.bf-content-dialog {
  margin-left: 3vw;
  margin-right: 3vw;
  margin-top: 3vh;
  color: #2b363b;
}

.bf-title-dialog {
  display: block;
  font-size: 3.1vh;
  margin-top: 4vh;
  text-align: center;
}

.bf-info-steps-dialog {
  margin: 1.5vh auto;
  line-height: 5vw;
}

.bf-info-steps-dialog .bf-info-steps .bf-step-number {
  margin: 2.5vh 4vw 0 2vw;
}

.bf-info-steps-dialog .bf-info-steps .bf-step {
  margin-top: 2.2vh;
}

.bf-dialog-button {
  color: #fff;
  border: #db0b27 1px solid;
  background-color: #db0b27;
  font-size: 4.7vw;
  text-align: center;
  width: 80%;
  margin: 5vh auto;
  padding: 1.5vh;
  font-weight: 800;
}

@media screen and (min-width: 768px) {
  .bf-clock-number {
    font-size: 11vh;
    line-height: 10vh;
  }

  .bf-clock-text {
    font-size: 2.2vh;
  }

  span.bf-icon {
    margin-top: 1vh;
  }

  span.bf-icon img {
    width: 6vw;
  }

  .bf-discount-prox,
  .bf-dates-info {
    height: 9vh;
    padding-top: 1vh;
  }

  span.bf-dialog-icon img {
    width: 8vw;
  }

  .mymodalblackfinde {
    margin: 15% auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/black-friday/black-friday.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,2DAA2D;EAC3D,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,qEAA8E;EAC9E,wBAAwB;EACxB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;;;;;;EAME,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,2DAA2D;EAC3D,UAAU;EACV,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;;IAEE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".appbar-black-finde > .app-bar-generic {\n  height: 6vh;\n  padding-top: 0;\n}\n\n.appbar-black-finde > .app-bar-generic > .parrafo-new-appbar {\n  margin-top: 0;\n}\n\n.appbar-black-finde\n  > .app-bar-generic\n  > .parrafo-new-appbar\n  > .icono-color-new-appbar {\n  color: #fff;\n}\n\n.bf-header-logo {\n  padding-top: 7vh;\n  padding-bottom: 4vh;\n  position: fixed;\n  width: 100vw;\n}\n\n.bf-logo {\n  margin: 0 auto;\n  margin-top: 2rem;\n  width: 90vw;\n}\n\n.bf-content {\n  font-family: \"RedHatDisplay-Regular\", sans-serif !important;\n  overflow-y: scroll;\n  position: relative;\n  top: 2vh;\n  width: 100vw;\n}\n\n.bf-background {\n  background: #e3e3e3 url(\"../assets/images/black-friday/bf22_bg.svg\") no-repeat;\n  background-size: contain;\n  height: 100vh;\n  overflow: scroll;\n  position: fixed;\n  z-index: -1;\n}\n\n.bf-counter-text {\n  font-weight: 900;\n  font-size: 1.2rem;\n  color: #fff;\n  line-height: 1.2rem;\n  text-align: left;\n  margin: 1rem 1.2rem;\n}\n\n.bf-counter {\n  margin: 0 auto;\n  width: 90vw;\n}\n\n.bf-clock-item {\n  background-color: #ffffff15;\n  border-radius: 10px;\n  color: #fff;\n  width: 17.5vw;\n  height: 17vw;\n  display: inline-block;\n  padding: 2vw 3vw;\n  margin: 1vw;\n  text-align: left;\n}\n\n.bf-clock-number {\n  font-size: 7.2vh;\n  font-weight: 800;\n  line-height: 6vh;\n  font-family: \"RedHatDisplay-Bold\" !important;\n}\n\n.bf-clock-text {\n  font-size: 1.7vh;\n}\n\n.bf-discount-prox,\n.bf-dates-info,\n.bf-promo-info {\n  border-radius: 4px;\n  margin: 0 auto;\n  margin-top: 2vh;\n  padding-top: 2vh;\n  padding-bottom: 2vh;\n  width: 90vw;\n}\n\n.bf-discount-prox {\n  background-color: #3a3a3a;\n}\n\n.bf-discount-img img {\n  max-width: 70vw;\n}\n\n.bf-dates-info,\n.bf-promo-info {\n  background-color: #fff;\n}\n\n.bf-promo-info {\n  height: auto;\n  margin-bottom: 2vh;\n  padding-bottom: 3vh;\n  padding-right: 2vw;\n  width: 88vw;\n}\n\nspan.bf-icon {\n  float: left;\n  margin: 0 3.5vw 0 5vw;\n}\n\nspan.bf-dialog-icon {\n  width: 16vw;\n  height: 16vw;\n  border-radius: 16px;\n  background-color: #000;\n  text-align: center;\n  position: relative;\n  display: block;\n  margin: 0 auto;\n}\n\nspan.bf-dialog-icon img {\n  position: absolute;\n  display: inline-block;\n  max-height: 100%;\n  max-width: 100%;\n  width: auto;\n  height: auto;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin: auto;\n}\n\n.bf-strong {\n  font-weight: 900 !important;\n  font-family: \"RedHatDisplay-Black\" !important;\n}\n\n.bf-prox-text,\n.bf-discount-info-text,\n.bf-info-text,\n.bf-info-header,\n.bf-info-steps,\n.bf-step {\n  display: block;\n  text-align: left;\n  font-size: 3.4vw;\n  font-weight: 900;\n  line-height: 5vw;\n}\n\n.bf-prox-text {\n  color: #fff;\n}\n\n.bf-info-text {\n  color: #2b363b;\n  font-weight: normal;\n  display: block;\n}\n\n.bf-discount-info-text {\n  color: #2b363b;\n  font-size: 3.4vw;\n}\n\n.bf-red {\n  color: #db0b27;\n  font-size: 3.4vw;\n}\n\n.bf-discount-info > .bf-red {\n  font-weight: normal;\n}\n\n.bf-discount {\n  background-color: #fff;\n  border-radius: 4px;\n  margin: 0 auto;\n  padding-top: 1.9vh;\n  padding-bottom: 1.9vh;\n  width: 90vw;\n}\n\n.bf-discount-info,\n.bf-discount-price,\n.bf-price-legend,\n.bf-price-cents {\n  display: block;\n}\n\n.bf-discount-price {\n  margin-top: 2vh;\n  font-weight: 900;\n}\n\n.bf-price-legend,\n.bf-price-cents {\n  color: #6ca452;\n}\n\n.bf-price-legend {\n  font-size: 3.4vw;\n  letter-spacing: 0.1em;\n}\n\n.bf-price-cents {\n  font-size: 2.5em;\n  margin-top: 1vh;\n}\n\n.bf-price-small {\n  color: #2b363b;\n  font-size: 0.4em;\n}\n\n.bf-step-number {\n  background-color: #db0b27;\n  color: #fff;\n  border-radius: 50%;\n  font-size: 0.8em;\n  padding: 0.2em 0.8em;\n  float: left;\n  margin: 3vh 5vw 0 5vw;\n  line-height: 1.8em;\n}\n\n.bf-step {\n  font-weight: 400;\n  margin-top: 3vh;\n  display: inline-block;\n  width: 78%;\n}\n\n.bf-link {\n  color: #db0b27;\n  font-weight: 800;\n}\n\n.mymodalblackfinde {\n  font-family: \"RedHatDisplay-Regular\", sans-serif !important;\n  z-index: 4;\n  left: 10vw;\n  width: 80vw;\n  background-color: #fff;\n  overflow: auto;\n  border-radius: 30px;\n  margin: 30% auto;\n}\n\n.mymodalblackfinde:focus-visible,\n.mymodalblackfinde:focus {\n  outline-width: 0;\n  outline: none;\n}\n\n.bf-content-dialog {\n  margin-left: 3vw;\n  margin-right: 3vw;\n  margin-top: 3vh;\n  color: #2b363b;\n}\n\n.bf-title-dialog {\n  display: block;\n  font-size: 3.1vh;\n  margin-top: 4vh;\n  text-align: center;\n}\n\n.bf-info-steps-dialog {\n  margin: 1.5vh auto;\n  line-height: 5vw;\n}\n\n.bf-info-steps-dialog .bf-info-steps .bf-step-number {\n  margin: 2.5vh 4vw 0 2vw;\n}\n\n.bf-info-steps-dialog .bf-info-steps .bf-step {\n  margin-top: 2.2vh;\n}\n\n.bf-dialog-button {\n  color: #fff;\n  border: #db0b27 1px solid;\n  background-color: #db0b27;\n  font-size: 4.7vw;\n  text-align: center;\n  width: 80%;\n  margin: 5vh auto;\n  padding: 1.5vh;\n  font-weight: 800;\n}\n\n@media screen and (min-width: 768px) {\n  .bf-clock-number {\n    font-size: 11vh;\n    line-height: 10vh;\n  }\n\n  .bf-clock-text {\n    font-size: 2.2vh;\n  }\n\n  span.bf-icon {\n    margin-top: 1vh;\n  }\n\n  span.bf-icon img {\n    width: 6vw;\n  }\n\n  .bf-discount-prox,\n  .bf-dates-info {\n    height: 9vh;\n    padding-top: 1vh;\n  }\n\n  span.bf-dialog-icon img {\n    width: 8vw;\n  }\n\n  .mymodalblackfinde {\n    margin: 15% auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
